import { get, post, put, del } from './client';

export const listarAjudaEmbedsAtivos = () => get('/ajuda-embeds');

export const listarAjudaEmbeds = () => get('/ajuda-embeds/todos');

export const criarAjudaEmbed = (dados) => post('/ajuda-embeds', dados);

export const atualizarAjudaEmbed = (id, dados) => put(`/ajuda-embeds/${id}`, dados);

export const removerAjudaEmbed = (id) => del(`/ajuda-embeds/${id}`);
